import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { TwoColumnsLayoutComponent } from './layouts/2-columns-layout/2-columns-layout.component';
import { LoginComponent } from './login/index';
import { TWO_COLUMN_ROUTES } from "./shared/routes/2-columns-layout.routes"


import { AuthGuard } from './shared/auth/auth-guard.service';
import { ChangePwdComponent } from './change-pwd/change-password-component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { ContactDetailsComponent } from './contact-details/contact-details.component';
import { PaymentResultComponent } from './payment-result/payment-result.component';

const appRoutes: Routes = [
  {
    path: 'home',
    redirectTo: 'home',
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
 
  { path: 'login', component: LoginComponent },
  {
    path:'change-pwd',
     component:ChangePwdComponent
  },
  {
    path: 'termscondition',
    component: TermsConditionsComponent
},{
    path: 'privacypolicy',
    component: PrivacyPolicyComponent
},{
    path: 'cookiepolicy',
    component: CookiePolicyComponent
},{
    path: 'contact-details',
    component: ContactDetailsComponent},
       
    {
      path: 'payment-redirect',
      loadChildren: './attraction-payment/attraction-payment.module#AttractionPaymentModule'
  },
  {
    path:'payment-result',
    component:PaymentResultComponent
  },
    
  { path: '', component: TwoColumnsLayoutComponent, data: { title: '' }, children: TWO_COLUMN_ROUTES, canActivate: [AuthGuard] },
 
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  declarations:[TermsConditionsComponent,PrivacyPolicyComponent,CookiePolicyComponent,ContactDetailsComponent],
  exports: [RouterModule]
})

export class AppRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts